<template>
  <div class="main_view">
    <iframe id ="home_view" class="home_view" :src="html_src" :style="{ height: screenHeight + 'px' }">
    </iframe>
  </div>
</template>

<script>
export default {
  name: "Mqtt",
  data(){
    return {
      html_src: '',
      screenHeight: ""
    }
  },
  mounted() {
    this.html_src = '/static/mqtt.html';
    this.screenHeight = window.innerHeight;
  },
  metaInfo: {
    title: "BAOWUDIY",
  }
}
</script>

<style scoped lang="stylus" rel="stylesheet/stylus">
.main_view
  width 100%
  height auto
  overflow hidden
  background-color black
  .home_view
    width 100%
    height auto
    border none
    overflow hidden
</style>



// WEBPACK FOOTER //
// src/components/Mqtt.vue